
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  commonModule,
  tasksModule,
  actionTypesModule,
  itemsModule,
  companyModule,
  dashboardModule,
  installationsModule,
  appointmentsModule,
} from "@/store/modules/store-accessor";
import { TimeUtil } from "@/helpers/TimeUtil";
import AssigneeCombo from "@/components/Combobox/AssigneeCombo.vue";
import { getOptimalTextColor, primaryInstallationItemText } from "@/helpers/data";
import _ from "lodash";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import AssigneeMultiUserCombo from '@/components/Combobox/AssigneeMultiUserCombo.vue'
import PriorityCombo from "@/components/Combobox/PriorityCombo.vue";
import AppointmentCalendar from "@/components/Calendar/AppointmentCalendar.vue";
import EventOverlappingWarning from "@/components/Alerts/EventOverlappingWarning.vue";
import { openInstallationSideview } from "@/helpers/installationSideview";
import InstallationItemWarrantyIndicator from "@/components/InstallationItemWarrantyIndicator.vue";
import { greekSearchFilter } from "@/helpers/data";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  components: {
    AssigneeCombo,
    AssigneeMultiUserCombo,
    PriorityCombo,
    AppointmentCalendar,
    EventOverlappingWarning,
    InstallationItemWarrantyIndicator,
  },
})
export default class AddTaskModal extends Vue {
  @Prop()
  payload!: any;

  greekSearchFilter = greekSearchFilter;

  payloadAssignee = {} as any;

  isEditingTask = false;
  loadingInstallationPrimaryItems = true;
  loadingInstallations = true;
  disableInstallationPrimaryItems = true;

  dateMenu = false;
  timeMenu = false;
  taskModel = {} as any;

  primaryInstallationItemsCombo = [] as any;

  payloadTaskModel = {} as any;

  updateAssignee(assignees: any) {
    // In calendar, assignee_id is user's full name instead of the id
    if(this.payload.quickEdit && this.payload.taskDetails.assignee_id) {
      this.taskModel.assignee_id = this.getAssigneeId(this.payload.taskDetails.assignee_id);
      this.taskModel.assignee_id = this.taskModel.assignee_id.id;
    }

    const assigneeId = typeof this.taskModel.assignee_id === 'object' ? this.taskModel.assignee_id?.id : this.taskModel.assignee_id;

    if(assigneeId) {
      this.taskModel.assignee_id = assignees.find((assingee: Record<string, any>) => assingee.id === assigneeId) || null;
    } else {
      this.taskModel.assignee_id = assignees?.[0]?.id || null;
    }

    this.taskModel.assignee =  assignees?.[0];
    this.taskModel.assignee_ids = assignees;
  }

  clearDatetime() {
    this.taskModel.scheduled_start_time = "";
    this.taskModel.all_day = false;
  }

  get actionsCombo() {
    return actionTypesModule.actionTypesCombo;
  }

  get installationPrimaryItems() {
    return itemsModule.installationPrimaryItems;
  }

  primaryItemText(item: Record<string, any>) {
    return primaryInstallationItemText(item);
  }

  get isLoadingInstallationPrimaryItems() {
    return this.loadingInstallationPrimaryItems;
  }

  get disablePrimaryItems() {
    return (
      this.loadingInstallationPrimaryItems ||
      this.installationPrimaryItems.length === 0
    );
  }

  get installationsCombo() {
    return commonModule.installationsCombo;
  }

  get isLoadingInstallations() {
    return this.loadingInstallations;
  }

  get installationDescriptionIsEnabled() {
    return (companyModule.company?.preferences as any)
      ?.installation_description;
  }

  optimalTextColor(color: string) {
    return getOptimalTextColor(color);
  }

  notesRule = [
    (val: any) => val?.length <= 1000 || this.$i18n.t("notesLengthRule"),
  ];
  titleRule = [
    (val: any) => !!val || this.$i18n.t("title_required"),
    (val: any) =>
      val == null ||
      val?.text?.length <= 300 ||
      val?.length <= 300 ||
      this.$i18n.t("form_title_length_rule"),
  ];
  scheduledTimeRules() {
    if (this.taskModel.due_at) {
      return [(val: any) => !!val || this.$i18n.t("timeRequired")];
    }
    return [];
  }

  async hideModal() {
    this.payload.isOrphanTask
      ? commonModule.hideSecondModal()
      : commonModule.hideModal();
    itemsModule.setInstallationPrimaryItems([]);
    tasksModule.setAddOrphanTaskInstallation('');
  }

  getAssigneeId(name: string) {
    const combo: any = commonModule.personnelPartnersCombo;
    const foundItem = combo.find((item: any) => item.name === name);
    if (foundItem) {
      return { name: foundItem.name, id: foundItem.id };
    } else {
      return "";
    }
  }

  itemName(obj: any) {
    const installationItemDescriptionIsEnabled = (companyModule.company?.preferences as any)?.installation_item_description;
    if(installationItemDescriptionIsEnabled) {
      obj = { ...obj, primary_items: `${obj.item_description ? obj.item_description + ' | ' : ''}${obj.primary_items}`}
    }
    this.primaryInstallationItemsCombo = this.installationPrimaryItems;
    const foundItem = this.primaryInstallationItemsCombo.find(
      (item: any) =>
        item.primary_items[0] == obj.primary_items && item.id === obj.id
    );
    if (foundItem) {
      return foundItem;
    } else {
      if (obj.id && obj.item_make) {
        let item_hidden_id = (Math.random() + 1).toString(36).substring(7);
        this.primaryInstallationItemsCombo.push({
          ...obj,
          disabled: true,
          hidden_id: item_hidden_id,
        });
        return {
          ...obj,
          disabled: true,
          hidden_id: item_hidden_id,
        };
      } else {
        return { primary_items: "", id: 0 };
      }
    }
  }

  async beforeMount() {
    itemsModule.setInstallationPrimaryItems([]);
    if (this.payload.task.installation_id) {
      await itemsModule.getInstallationPrimaryInventoryItems(
        this.payload.task.installation_id
      );
    } else {
      this.loadingInstallations = true;
      commonModule.getInstallationsCombo();
      this.loadingInstallations = false;
    }
    actionTypesModule.getActionTypesCombo();

    this.payloadTaskModel.id = this.payload.task.id;
    this.payloadTaskModel.due_at = this.formatEditDate(
      this.payload.task.due_at,
      this.payload.task.all_day
    );
    this.payloadTaskModel.assignee_id = this.payload.task.assignee?.id;
    this.payloadTaskModel.assignee = this.payload.task.assignee;
    this.payloadTaskModel.assignee_ids =this.payload.task.assignee_ids;
    this.payloadTaskModel.assignees =this.payload.task.assignees;
    this.payloadTaskModel.installation_id = this.payload.task.installation_id;
    this.payloadTaskModel.task_status_id = this.payload.task.task_status_id;
    this.payloadTaskModel.title = this.payload.task.title
      ? this.payload.task.title
      : this.payload.task.category.includes(1)
      ? this.$i18n.t("reminder_label")
      : "";
    this.payloadTaskModel.notes = this.payload.task.notes || "";
    this.payloadTaskModel.action_type_id =
      this.payload.task.action_type_id || null;
    this.payloadTaskModel.installation_item_id = this.itemName({
      primary_items: this.payload.task.task_item,
      id: this.payload.task.installation_item_id,
      item_type_text: this.payload.task.item_type_text,
      item_make: this.payload.task.item_make,
      item_model: this.payload.task.item_model,
      item_serial_no: this.payload.task.item_serial_no,
      item_description: this.payload.task.item_description,
    });
    this.payloadTaskModel.partner_id = this.payload.task.partner_id || "";
    this.payloadTaskModel.all_day = this.payload.task.all_day;
    this.payloadTaskModel.scheduled_start_time =
      this.payloadTaskModel.all_day === false
        ? this.formatEditDateTime(this.payload.task.due_at)
        : "";
    this.payloadTaskModel.priority_name = this.payload.task.priority_name;
    this.taskModel = _.cloneDeep(this.payloadTaskModel);
  }

  async getInstallationId(selectedInstallationId: string) {
    this.payloadTaskModel.installation_item_id = null;
    this.loadingInstallationPrimaryItems = true;
    this.disableInstallationPrimaryItems = true;
    tasksModule.setAddOrphanTaskInstallation(selectedInstallationId);
    if (selectedInstallationId) {
      this.itemName(await itemsModule.getInstallationPrimaryInventoryItems(selectedInstallationId))
    } else {
      itemsModule.setInstallationPrimaryItems([]);
    }
    this.loadingInstallationPrimaryItems = false;
    this.disableInstallationPrimaryItems = false;
  }

  async mounted() {
    commonModule.initSnackbar({});
    commonModule.getPersonnelPartnersCombo();
    this.loadingInstallationPrimaryItems = false;
  }

  get editDisabled() {
    return _.isEqual(this.taskModel, this.payloadTaskModel);
  }

  get showTimeInput() {
    return !this.taskModel.all_day;
  }

  formatDate(date: Date) {
    if (date == undefined || date == null) {
      return this.$i18n.t("pending");
    } else {
      return TimeUtil.formatDate(date);
    }
  }

  formatEditDate(date: Date, allDay = false): string {
    if (allDay && date) {
      const companyTimezone = companyModule.company?.timezone || dayjs.tz.guess();
      return dayjs.tz(date, companyTimezone).format("YYYY-MM-DD");
    }

    return TimeUtil.formatDateOnly(date);
  }

  formatEditDateTime(date: Date): string {
    return TimeUtil.formatTimeOnly(date);
  }

  installationText(item: any) {
    let installation_arr = item.is_business
      ? [
          item.tag_id.split("_").pop(),
          `${item.address ? item.address : item.area}`,
          item.description && this.installationDescriptionIsEnabled
            ? item.description
            : "",
          `${item.entity_name} (${item.client_name})`,
          item.phone,
        ]
      : [
          item.tag_id.split("_").pop(),
          `${item.address ? item.address : item.area}`,
          item.description && this.installationDescriptionIsEnabled
            ? item.description
            : "",
          item.client_name,
          item.phone,
        ];

    return installation_arr.filter(Boolean).join(" | ");
  }

  get newAddOrphanInstallation() {
    this.taskModel.installation_id = tasksModule.addOrphanTaskInstallation;
    if(this.taskModel.installation_id) {
      this.getInstallationId(this.taskModel.installation_id);
    }

    return tasksModule.addOrphanTaskInstallation;
  }

  set newAddOrphanInstallation(value) {
    this.taskModel.installation_id = value;
  }

  openAddClientAndInstallationModal() {
    commonModule.showThirdModal({ name: 'quick-add-calendar-modal', payload: { isOrphanTask: true, isThirdModal: true } });
  }


  async doEditTask() {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      let taskModelCopy = _.cloneDeep(this.taskModel);

      this.isEditingTask = true;
      await tasksModule.editTask(taskModelCopy);
      this.isEditingTask = false;

      if (this.$route.name === "Dashboard") {
        dashboardModule.getDashboardPendingTasks(dashboardModule.taskFilters);
      } else if (this.$route.name === "Calendar") {
        appointmentsModule.unsetCalendarAppointments();
        appointmentsModule.getCalendarAppointmentsAction(
          appointmentsModule.filters
        );
      }

      if (this.payload.isOrphanTask && this.taskModel.installation_id) {
        commonModule.hideSecondModal();
        commonModule.hideModal();

        tasksModule.setIsLoadingTable(false);
        await openInstallationSideview({
          installationId: this.taskModel.installation_id,
          tab: 'tasks',
          taskId: this.taskModel.id,
        });
      }

      this.hideModal();
    }
  }
}
